export default __webpack_public_path__ + "static/cactus-72670ec87139de1cfc4b4425a99f40f0.png";